// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.currency-chooser {
  width: min(720px, 100vw - 32px);
  max-width: 720px !important;
  max-height: min(720px, 100vh - 32px);
  overflow: auto;
  padding: 28px !important;
  color: #0F1C32;
  background: #FFFFFF;
  border: 1px solid #E2E8F0;
  border-radius: 16px !important;
}
.currency-chooser__header {
  gap: 5px !important;
  padding-inline-end: 32px;
  text-align: start !important;
}
.currency-chooser__eyebrow {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  color: #B8953D;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.09em;
  text-transform: uppercase;
}
.currency-chooser__header h2 {
  color: #1B2B4B;
  font-size: 26px;
}
.currency-chooser__header p:last-child {
  color: #64748B;
}
.currency-chooser__search {
  display: flex;
  align-items: center;
  gap: 9px;
  min-height: 48px;
  margin: 24px 0;
  padding: 0 14px;
  color: #94A3B8;
  background: #FAFBFD;
  border: 1px solid #E2E8F0;
  border-radius: 9px;
}
.currency-chooser__search:focus-within {
  border-color: #C9A84C;
  box-shadow: 0 0 0 3px rgba(201, 168, 76, 0.28);
}
.currency-chooser__search input {
  width: 100%;
  color: #0F1C32;
  background: transparent;
  border: 0;
  outline: 0;
  font: inherit;
}
.currency-chooser__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin: 0;
  padding: 0;
  list-style: none;
}
.currency-chooser__grid li {
  min-width: 0;
}
.currency-chooser__option {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
  min-height: 78px;
  padding: 12px;
  text-align: start;
  color: #0F1C32;
  background: #FFFFFF;
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  cursor: pointer;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}
.currency-chooser__option:hover {
  border-color: #C9A84C;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
  transform: translateY(-1px);
}
.currency-chooser__option:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(201, 168, 76, 0.28);
}
.currency-chooser__option--selected {
  color: #1B2B4B;
  background: #FDF8EE;
  border-color: #C9A84C;
}
.currency-chooser__symbol {
  display: grid;
  place-items: center;
  width: 30px;
  height: 30px;
  color: #1B2B4B;
  background: #EEF2F8;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 700;
}
.currency-chooser__details {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 2px;
}
.currency-chooser__details strong {
  font-size: 13px;
}
.currency-chooser__details span {
  overflow: hidden;
  color: #64748B;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.currency-chooser__check {
  margin-inline-start: auto;
  color: #16A34A;
  flex: 0 0 auto;
}
.currency-chooser__empty {
  margin: 0;
  padding: 24px;
  color: #64748B;
  text-align: center;
}
@media (max-width: 600px) {
  .currency-chooser {
    padding: 22px 18px !important;
  }
  .currency-chooser__grid {
    grid-template-columns: 1fr;
  }
}
body.dark-mode .currency-chooser {
  color: #F1F5F9;
  background: #0F1C32;
  border-color: #1E3055;
}
body.dark-mode .currency-chooser__header h2, body.dark-mode .currency-chooser__search input, body.dark-mode .currency-chooser__option {
  color: #F1F5F9;
}
body.dark-mode .currency-chooser__search, body.dark-mode .currency-chooser__option {
  background: #162444;
  border-color: #1E3055;
}
body.dark-mode .currency-chooser__option--selected {
  background: rgba(201, 168, 76, 0.18);
  border-color: #C9A84C;
}
body.dark-mode .currency-chooser__details span {
  color: #94A3B8;
}

html[dir=rtl] .currency-chooser > button {
  right: auto;
  inset-inline-end: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/CurrencyChooserModal.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;EACE,+BAAA;EACA,2BAAA;EACA,oCAAA;EACA,cAAA;EACA,wBAAA;EACA,cCckB;EDblB,mBCSkB;EDRlB,yBAAA;EACA,8BAAA;AADF;AAGE;EAAY,mBAAA;EAAqB,wBAAA;EAA0B,4BAAA;AAE7D;AADE;EAAa,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,SAAA;EAAW,cCLpD;EDKwE,eAAA;EAAiB,gBCwEtF;EDxEsH,sBAAA;EAAuB,yBAAA;AAYpK;AAXE;EAAe,cCZG;EDYoB,eAAA;AAexC;AAdE;EAAyB,cCOP;ADUpB;AAhBE;EAAY,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,gBAAA;EAAkB,cAAA;EAAuB,eAAA;EAAiB,cCOlG;EDPsH,mBCEtH;EDFgJ,yBAAA;EAAiC,kBAAA;AA4BrM;AA3BE;EAAyB,qBCVP;EDUkC,8CCmDrC;ADpBjB;AA9BE;EAAkB,WAAA;EAAa,cCGb;EDHiC,uBAAA;EAAyB,SAAA;EAAW,UAAA;EAAY,aAAA;AAsCrG;AArCE;EAAU,aAAA;EAAe,gDAAA;EAAkD,SAAA;EAAW,SAAA;EAAW,UAAA;EAAY,gBAAA;AA6C/G;AA5CE;EAAa,YAAA;AA+Cf;AA9CE;EAAY,kBAAA;EAAoB,aAAA;EAAe,mBAAA;EAAqB,WAAA;EAAa,SAAA;EAAW,gBAAA;EAAkB,aAAA;EAAe,iBAAA;EAAmB,cAAA;EAAoB,mBCJlJ;EDI8K,yBAAA;EAAiC,mBAAA;EAAqB,eAAA;EAAiB,gFAAA;AA8DzQ;AA7DI;EAAU,qBCfM;EDeqB,yCC0CxB;ED1CgD,2BAAA;AAkEjE;AAjEI;EAAkB,aAAA;EAAe,8CC6CpB;ADwBjB;AApEI;EAAc,cCtBE;EDsBqB,mBCfrB;EDe8C,qBCjB9C;AD0FpB;AAvEE;EAAY,aAAA;EAAe,mBAAA;EAAqB,WAAA;EAAa,YAAA;EAAc,cCxBzD;EDwBgF,mBCtBhF;EDsB4G,kBAAA;EAAoB,eAAA;EAAiB,gBC2D9I;ADuBvB;AAjFE;EAAa,aAAA;EAAe,YAAA;EAAc,sBAAA;EAAwB,QAAA;AAuFpE;AAvFgF;EAAoB,eCiD7E;ADyCvB;AA1FgI;EAAkB,gBAAA;EAAkB,cCLhJ;EDKmK,eAAA;EAAiB,uBAAA;EAAyB,mBAAA;AAiGjO;AAhGE;EAAW,yBAAA;EAA2B,cCGpB;EDH2C,cAAA;AAqG/D;AApGE;EAAW,SAAA;EAAW,aCsBV;EDtBgC,cCP1B;EDO6C,kBAAA;AA0GjE;AAxGE;EA9BF;IA8B8B,6BAAA;EA4G5B;EA5G2D;IAAU,0BAAA;EA+GrE;AACF;AA/GE;EAAmB,cCQC;EDRkB,mBCKlB;EDL6C,qBCU7C;AD0GtB;AApH+F;EAA2C,cCQpH;AD+GtB;AAvH+J;EAAuB,mBCMhK;EDN6L,qBCU7L;ADiHtB;AA3HiP;EAAsB,oCAAA;EAAoC,qBCzBvR;ADwJpB;AA/HwU;EAAkB,cCSpU;ADyHtB;;AA/HA;EACE,WAAA;EACA,sBAAA;AAkIF","sourcesContent":["@import '../styles/variables';\n\n.currency-chooser {\n  width: min(720px, calc(100vw - 32px));\n  max-width: 720px !important;\n  max-height: min(720px, calc(100vh - 32px));\n  overflow: auto;\n  padding: 28px !important;\n  color: $text-color;\n  background: $surface-white;\n  border: 1px solid $border-color;\n  border-radius: $border-radius-lg !important;\n\n  &__header { gap: 5px !important; padding-inline-end: 32px; text-align: start !important; }\n  &__eyebrow { display: flex; align-items: center; gap: 6px; margin: 0; color: $gold-hover; font-size: 11px; font-weight: $font-weight-bold; letter-spacing: .09em; text-transform: uppercase; }\n  &__header h2 { color: $primary-color; font-size: 26px; }\n  &__header p:last-child { color: $text-gray; }\n  &__search { display: flex; align-items: center; gap: 9px; min-height: 48px; margin: $spacing-lg 0; padding: 0 14px; color: $text-muted; background: $surface-off; border: 1px solid $border-color; border-radius: 9px; }\n  &__search:focus-within { border-color: $gold-color; box-shadow: $shadow-focus; }\n  &__search input { width: 100%; color: $text-color; background: transparent; border: 0; outline: 0; font: inherit; }\n  &__grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 10px; margin: 0; padding: 0; list-style: none; }\n  &__grid li { min-width: 0; }\n  &__option { position: relative; display: flex; align-items: center; width: 100%; gap: 10px; min-height: 78px; padding: 12px; text-align: start; color: $text-color; background: $surface-white; border: 1px solid $border-color; border-radius: 10px; cursor: pointer; transition: border-color $transition, box-shadow $transition, transform $transition;\n    &:hover { border-color: $gold-color; box-shadow: $shadow-sm; transform: translateY(-1px); }\n    &:focus-visible { outline: none; box-shadow: $shadow-focus; }\n    &--selected { color: $primary-color; background: $gold-light; border-color: $gold-color; }\n  }\n  &__symbol { display: grid; place-items: center; width: 30px; height: 30px; color: $primary-color; background: $primary-light; border-radius: 50%; font-size: 14px; font-weight: $font-weight-bold; }\n  &__details { display: flex; min-width: 0; flex-direction: column; gap: 2px; } &__details strong { font-size: $font-size-sm; } &__details span { overflow: hidden; color: $text-gray; font-size: 11px; text-overflow: ellipsis; white-space: nowrap; }\n  &__check { margin-inline-start: auto; color: $success-color; flex: 0 0 auto; }\n  &__empty { margin: 0; padding: $spacing-lg; color: $text-gray; text-align: center; }\n\n  @media (max-width: 600px) { padding: 22px 18px !important; &__grid { grid-template-columns: 1fr; } }\n  body.dark-mode & { color: $dark-text; background: $dark-surface; border-color: $dark-border; &__header h2, &__search input, &__option { color: $dark-text; } &__search, &__option { background: $dark-surface-2; border-color: $dark-border; } &__option--selected { background: rgba($gold-color, .18); border-color: $gold-color; } &__details span { color: $dark-text-secondary; } }\n}\n\nhtml[dir='rtl'] .currency-chooser > button {\n  right: auto;\n  inset-inline-end: 1rem;\n}","﻿// --- Yet2Book Design System --- Royal Navy x Warm Gold -----------------------\n\n// -- Brand Palette -------------------------------------------------------------\n$primary-color:     #1B2B4B;\n$primary-hover:     #0F1C32;\n$primary-light:     #EEF2F8;\n$primary-border:    #C4CDD8;\n\n$gold-color:        #C9A84C;\n$gold-hover:        #B8953D;\n$gold-light:        #FDF8EE;\n$gold-border:       #E8D5A3;\n\n$secondary-color:   #0F1C32;\n$accent-color:      #EEF2F8;\n\n// -- Surfaces ------------------------------------------------------------------\n$background-light:  #F7F8FA;\n$surface-white:     #FFFFFF;\n$surface-off:       #FAFBFD;\n\n// -- Typography ----------------------------------------------------------------\n$text-color:        #0F1C32;\n$text-gray:         #64748B;\n$text-muted:        #94A3B8;\n\n// -- Borders -------------------------------------------------------------------\n$border-color:      #E2E8F0;\n$border-strong:     #CBD5E1;\n\n// -- Semantic ------------------------------------------------------------------\n$error-color:       #DC2626;\n$success-color:     #16A34A;\n$warning-color:     #D97706;\n$info-color:        #2563EB;\n\n// -- Dark Mode -----------------------------------------------------------------\n$dark-bg:             #09111E;\n$dark-surface:        #0F1C32;\n$dark-surface-2:      #162444;\n$dark-surface-hover:  #1E2F4D;\n$dark-text:           #F1F5F9;\n$dark-text-secondary: #94A3B8;\n$dark-border:         #1E3055;\n$dark-input-bg:       #0B1527;\n$dark-input-border:   #263A5E;\n$dark-shadow:         rgba(0, 0, 0, 0.8);\n\n// -- Spacing -------------------------------------------------------------------\n$spacing-xs:  4px;\n$spacing-sm:  8px;\n$spacing-md:  16px;\n$spacing-lg:  24px;\n$spacing-xl:  40px;\n$spacing-xxl: 64px;\n\n// -- Layout --------------------------------------------------------------------\n$border-radius:    10px;\n$border-radius-lg: 16px;\n$border-radius-xl: 24px;\n$transition:       0.18s ease;\n$theme-transition: all 0.25s ease;\n\n// -- Shadows -------------------------------------------------------------------\n$shadow-xs:      0 1px 3px rgba(0, 0, 0, 0.06);\n$shadow-sm:      0 2px 8px rgba(0, 0, 0, 0.07);\n$shadow-md:      0 4px 20px rgba(0, 0, 0, 0.09);\n$shadow-lg:      0 8px 40px rgba(0, 0, 0, 0.12);\n$shadow-xl:      0 16px 64px rgba(0, 0, 0, 0.16);\n$shadow-focus:   0 0 0 3px rgba(201, 168, 76, 0.28);\n$shadow-dark-md: 0 4px 24px rgba(0, 0, 0, 0.6);\n$shadow-gold:    0 4px 20px rgba(201, 168, 76, 0.35);\n\n// -- Typography ----------------------------------------------------------------\n$font-family:          'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n$font-family-display:  'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n$font-size-xs:         11px;\n$font-size-sm:         13px;\n$font-size-base:       15px;\n$font-size-lg:         16px;\n$font-size-xl:         18px;\n$font-size-xxl:        24px;\n$font-size-xxxl:       32px;\n$font-weight-normal:   400;\n$font-weight-medium:   500;\n$font-weight-semibold: 600;\n$font-weight-bold:     700;\n$font-weight-black:    800;\n\n// -- Legacy Aliases ------------------------------------------------------------\n$light-gray:  $accent-color;\n$text-dark:   $text-color;\n$ocean-blue:  $primary-color;\n$ocean-light: $primary-light;\n$radius-sm:   6px;\n$radius-md:   $border-radius;\n$radius-lg:   $border-radius-lg;\n\n// -- Admin Sidebar -------------------------------------------------------------\n$admin-sidebar-width:         240px;\n$admin-sidebar-collapsed-width: 64px;\n$admin-topbar-height:         60px;\n\n$admin-sidebar-bg:            #0B1527;\n$admin-sidebar-border:        #1A2E4A;\n$admin-sidebar-text:          #94A3B8;\n$admin-sidebar-text-hover:    #CBD5E1;\n$admin-sidebar-active:        #FFFFFF;\n$admin-sidebar-active-bg:     rgba(37, 99, 235, 0.18);\n$admin-sidebar-active-border: #2563EB;\n$admin-sidebar-icon:          #64748B;\n$admin-sidebar-icon-active:   #2563EB;\n$admin-sidebar-badge:         #EF4444;\n\n$admin-topbar-bg:             #FFFFFF;\n$admin-topbar-border:         #E2E8F0;\n$admin-topbar-shadow:         0 1px 3px rgba(0,0,0,0.08);\n\n$admin-content-bg:            #F1F5F9;\n$admin-card-bg:               #FFFFFF;\n$admin-card-shadow:           0 1px 4px rgba(0,0,0,0.06);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
